import { useTheme } from '@/contexts/ThemeContext';

/**
 * The logo mark at the head of a public page (privacy, support). A plain
 * anchor, not a router Link: these pages render with no providers at all,
 * because that is how a store reviewer opens them.
 */
export function PageMark() {
  const mark = useTheme().scheme === 'dark' ? '/brand/mark-ivory.png' : '/brand/mark-teal.png';
  return (
    <a href="/" className="inline-flex items-center gap-3" aria-label="فصّلت">
      <img src={mark} alt="" className="h-11 w-auto" />
      {/* The motto beside the mark (owner, 2026-10-10). Written out, not
          translated: this page renders without the language provider. */}
      <span aria-hidden="true" className="whitespace-nowrap text-lg font-semibold text-accent">تصحيح التلاوة</span>
    </a>
  );
}
